var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#48BEFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.194 26.239L5.81 14.744a4.247 4.247 0 010-6.953L9.78 5l16.386 11.494a4.247 4.247 0 010 6.953l-3.972 2.792zM9.776 6.863L6.683 9.027a2.729 2.729 0 000 4.473l15.514 10.877 3.094-2.164a2.729 2.729 0 000-4.473L9.776 6.863z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.763 24.377l-3.09-2.167a2.729 2.729 0 010-4.473l8-5.583-1.32-.928-7.544 5.268a4.247 4.247 0 000 6.953l3.957 2.779 4.897-3.429-1.314-.926-3.586 2.506zM26.17 7.797L22.21 5.02l-4.9 3.429 1.314.925 3.58-2.505 3.09 2.167a2.729 2.729 0 010 4.473l-8 5.582 1.315.926 7.554-5.277a4.247 4.247 0 000-6.953l.008.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.746 15.829l6.23-4.362.868 1.24-6.231 4.362zm17.75-1.758l-3.035 2.125.868 1.241 3.142-2.204c-.334-.382-.657-.772-.981-1.163l.006.001z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoom);
export default __webpack_public_path__ + "static/media/loom.018a0d713a647613ad5f1acb4c439634.svg";
export { ForwardRef as ReactComponent };